module.exports = __webpack_public_path__ + "img/signature.f8f64613.svg";